import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { StaticImage, getImage, GatsbyImage } from "gatsby-plugin-image"
import StreamVideo from "../stream-video"

const VideoListFromJson = ({ list, htmlTitle, defaultTab, defaultType }) => {
  // Dropdown
  const [isExpanded, setIsExpanded] = useState(false)

  // Handle main
  const videoListData = useVideoListJson()
  const data = videoListData.filter(item => item.name === list)
  const tabs = data[0][`children${list}Json`]

  // Handle Default Tab
  defaultTab = defaultTab?.replace("_", " ")
  let indexDefaultTab = tabs.findIndex(item => item.Name === defaultTab)
  indexDefaultTab = indexDefaultTab !== -1 ? indexDefaultTab : 0

  // Handle Default Type
  let indexDefaultType = tabs[indexDefaultTab]?.Types?.findIndex(
    item => item.Name.replace(/[^a-zA-Z]/g, "") === defaultType
  )
  indexDefaultType = indexDefaultType !== -1 ? indexDefaultType : 0

  const [tabSelected, setTabSelected] = useState(tabs[indexDefaultTab])
  const [typeSelected, setTypeSelected] = useState(
    tabs[indexDefaultTab].Types[indexDefaultType]
  )
  const [songSelected, setSongSelected] = useState(
    tabs[indexDefaultTab].Types[indexDefaultType].Songs[0]
  )

  const handleChangeTab = tab => {
    setTabSelected(tab)
    setTypeSelected(tab.Types[0])
    setSongSelected(tab.Types[0].Songs[0])
  }

  const handleChangeType = type => {
    setTypeSelected(type)
    setSongSelected(type.Songs[0])
  }

  const handleSelectSong = song => {
    setSongSelected(song)
  }

  const goToType = idx => {
    const newIdx =
      idx < 0
        ? tabSelected.Types.length - 1
        : idx > tabSelected.Types.length - 1
        ? 0
        : idx
    handleChangeType(tabSelected.Types[newIdx])
  }

  return (
    <div className="max-w-screen-2xl mx-7 2xl:mx-auto">
      <div
        className="mb-10"
        dangerouslySetInnerHTML={{ __html: htmlTitle }}
      ></div>
      <div className="hidden lg:flex relative top-4px flex-row lg:mx-10 z-10 mt-[87px]">
        {tabs.map(tab => {
          const tabImage = getImage(tab.Image)
          return (
            <div
              className={`w-1/5 bg-primary ${
                tabSelected.Name === tab.Name
                  ? "lg:border-b-0 font-bold border-4 border-color-secondary"
                  : "text-secondary border border-b-4"
              }`}
              key={tab.Id}
            >
              <button
                onClick={() => handleChangeTab(tab)}
                className={`w-full flex justify-center flex-col p-4`}
              >
                <div className="mx-auto">
                  {tab.Image && <GatsbyImage image={tabImage} alt="tab" />}
                </div>
                <p className="xl:mt-2 underline block mx-auto xl:font-syne--22 font-bold">
                  {tab.Name}
                </p>
              </button>
            </div>
          )
        })}
      </div>
      <div className="lg:hidden relative top-4px">
        <div>
          <div
            role="button"
            tabIndex={0}
            className="group relative w-full outline-none"
            onClick={() => setIsExpanded(!isExpanded)}
            onKeyDown={() => setIsExpanded(!isExpanded)}
          >
            <button className="w-full py-5 rounded border xl:border-b-0 font-bold border-4 border-color-secondary flex flex-row items-center justify-center font-montserrat--14">
              {tabSelected.Name}
              <div className="ml-3">
                <StaticImage
                  src="../../static/images/icon/angle-arrow-down.svg"
                  alt="angle-arrow-down.svg"
                />
              </div>
            </button>
            <div
              className={`border border-2 bg-primary border-gray-800 rounded w-full z-10 absolute left-0 top-3/4 transition-all ${
                isExpanded
                  ? "visible opacity-100 translate-y-1"
                  : "invisible opacity-0"
              }`}
            >
              <ul className="py-1 font-montserrat--14">
                {tabs.map(tab => {
                  return (
                    <li
                      className={tab.Name === tabSelected.Name ? "hidden" : ""}
                      key={tab.Name}
                    >
                      <button
                        className="block px-4 py-2 text-center"
                        onClick={() => handleChangeTab(tab)}
                      >
                        {tab.Name}
                      </button>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="border relative border-t-4 border-color-secondary">
        {/* {loading && (
          <div className="absolute w-full h-full z-10">
            <div
              className="absolute w-full h-full z-10 opacity-70"
              style={{ backgroundColor: "#fff" }}
            ></div>
            <div className="absolute left-0 right-0 top-0 bottom-0 z-20 flex items-center justify-center w-full h-full">
              <div className="flex flex-row items-end space-x-3">
                <StaticImage
                  width={300}
                  src="../../static/images/icon/redsoda-logo-light.svg"
                  alt="icon/redsoda-logo-light"
                  formats={["auto", "webp", "avif"]}
                />
                <div className="flex flex-row space-x-2">
                  <div
                    style={{ backgroundColor: "#CE2D41" }}
                    className="w-8 h-8 rounded-full animate-bounce"
                  ></div>
                  <div className="w-8 h-8 bg-black rounded-full animate-bounce-1"></div>
                  <div
                    style={{ backgroundColor: "#CE2D41" }}
                    className="w-8 h-8 rounded-full animate-bounce-2"
                  ></div>
                  <div className="w-8 h-8 bg-black rounded-full animate-bounce-3"></div>
                </div>
              </div>
            </div>
          </div>
        )} */}
        <div className="lg:px-10 xl:px-20 lg:grid lg:grid-cols-4 xl:grid-cols-4 lg:grid-flow-row-dense">
          <div className=""></div>
          <div className="lg:col-span-3 xl:col-span-3 lg:grid grid-cols-4 font-bold mt-12 gap-x-10 xl:gap-x-5 gap-y-3">
            {tabSelected.Types.map((type, idx) => {
              return (
                <div key={type.Id}>
                  <div
                    className={`lg:hidden text-right mb-5 mr-5 sm:mr-10 ${
                      type.Name === typeSelected.Name ? "" : "hidden"
                    }`}
                  >
                    <button onClick={() => goToType(idx - 1)} className="mr-5">
                      <StaticImage
                        src="../../static/images/icon/angle-arrow-left.svg"
                        alt="arrow"
                      />
                    </button>
                    <button onClick={() => goToType(idx + 1)}>
                      <StaticImage
                        src="../../static/images/icon/angle-arrow-right.svg"
                        alt="arrow"
                      />
                    </button>
                  </div>
                  <button
                    className={`${
                      type.Id === typeSelected.Id ? "underline" : ""
                    } font-bold text-left hidden lg:inline-block uppercase tracking-[1.2px]`}
                    onClick={() => handleChangeType(type)}
                  >
                    {type.Name}
                  </button>
                </div>
              )
            })}
          </div>
        </div>
        <p className="font-syne--22 mt-10 xl:font-syne--26 font-bold mb-5 mx-5 md:mx-10 xl:mx-20 uppercase">
          {typeSelected.Name}
        </p>
        <div className="mt-5 lg:pl-10 lg:pr-5 xl:pl-20 xl:pr-10 flex flex-col w-full">
          <div className="flex relative flex-1 lg:flex-row flex-col">
            <div className="w-full lg:w-2/3 lg:pr-16">
              <StreamVideo
                src={songSelected.VideoId}
                poster={songSelected.Image.replace(
                  "#GATSBY_STATIC_IMAGE_URL#",
                  process.env.GATSBY_STATIC_IMAGE_URL
                )}
              />
            </div>
            <div className="lg:absolute top-0 w-full lg:w-1/3 h-[350px] lg:h-[100%] overflow-auto right-0 xl:pr-10 lg:pr-5">
              {typeSelected.Songs.map((song, index) => {
                return (
                  <button
                    className={`pl-2 hover:bg-[#f3ede6] h-[25%] xl:h-[20%] 2xl:h-[16.66%] ${
                      index === 0 ? "border-t " : ""
                    }border-b py-5 block w-full text-left ${
                      song.Id === songSelected.Id ? "bg-[#f3ede6]" : ""
                    }`}
                    onClick={() => handleSelectSong(song)}
                    key={song.Id}
                  >
                    <p className="font-bold">{song.Name}</p>
                    <p>{song.Artist}</p>
                  </button>
                )
              })}
            </div>
          </div>
          <div className="w-full">
            <p className="font-syne font-semibold mt-5 mb-10 hidden lg:block">
              {songSelected.Name}{" "}
              <span className="hidden lg:inline-block">-</span>
              <br className="lg:hidden" /> {songSelected.Artist}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoListFromJson

const useVideoListJson = () => {
  const { allFile } = useStaticQuery(
    graphql`
      query MyQuery {
        allFile(
          filter: {
            name: {
              in: [
                "SydneyBandList"
                "SydneySongList"
                "BostonBandList"
                "BostonSongList"
                "TorontoBandList"
                "TorontoSongList"
              ]
            }
          }
        ) {
          nodes {
            id
            name
            childrenSydneyBandListJson {
              Id
              Name
              Image {
                childImageSharp {
                  gatsbyImageData
                }
              }
              Types {
                Id
                Name
                Songs {
                  Id
                  Artist
                  Image
                  Name
                  VideoId
                }
              }
            }
            childrenSydneySongListJson {
              Id
              Name
              Image {
                childImageSharp {
                  gatsbyImageData
                }
              }
              Types {
                Id
                Name
                Songs {
                  Artist
                  Id
                  Image
                  VideoId
                  Name
                }
              }
            }
            childrenBostonSongListJson {
              Id
              Name
              Image {
                childImageSharp {
                  gatsbyImageData
                }
              }
              Types {
                Id
                Name
                Songs {
                  Id
                  Artist
                  Image
                  Name
                  VideoId
                }
              }
            }
            childrenBostonBandListJson {
              Id
              Name
              Image {
                childImageSharp {
                  gatsbyImageData
                }
              }
              Types {
                Id
                Name
                Songs {
                  Artist
                  Id
                  Image
                  VideoId
                  Name
                }
              }
            }
            childrenTorontoBandListJson {
              Id
              Name
              Image {
                childImageSharp {
                  gatsbyImageData
                }
              }
              Types {
                Id
                Name
                Songs {
                  Id
                  Artist
                  Image
                  Name
                  VideoId
                }
              }
            }
            childrenTorontoSongListJson {
              Id
              Name
              Image {
                childImageSharp {
                  gatsbyImageData
                }
              }
              Types {
                Id
                Name
                Songs {
                  Artist
                  Id
                  Image
                  VideoId
                  Name
                }
              }
            }
          }
        }
      }
    `
  )

  return allFile.nodes
}
